module.exports = __webpack_public_path__ + "img/logo-bluebox.bd99241a.svg";